<template>
  <div class="pb-2">
    <div v-if="this.loadpage == false" class="text-center">
      <b-spinner
        style="width: 5rem; height: 5rem;"
        variant="primary"
        label="Large Spinner"
      />
    </div>
    <div v-if="this.loadpage == true">
      <!-- company info -->
      <b-card no-body>
        <b-card-header>
          <h4>ข้อมูลบริษัท</h4>
        </b-card-header>
        <b-card-body>
          <b-row>
            <b-col cols="12">
              <b-form-group
                class="font-weight-slim"
                label="ชื่อบริษัท :"
                label-cols-md="3"
              >
                <div class="align-items-center">
                  <b-form-input v-model="companyName" class="col-md-7"/>
                  <span v-if="this.valName == false" style="color:red">*กรุณาระบุ</span>
                </div>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group
                class="font-weight-slim"
                label="เบอร์โทรบริษัท :"
                label-cols-md="3"
              >
                <div class="align-items-center">
                  <b-form-input v-model="companyPhone" class="col-md-7"/>
                </div>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group
                class="font-weight-slim"
                label="ที่อยู่บริษัท :"
                label-cols-md="3"
              >
                <div class="align-items-center">
                  <b-form-textarea v-model="companyAddress" class="col-md-7"/>
                  <span v-if="this.valAddress == false" style="color:red">*กรุณาระบุ</span>
                </div>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group
                class="font-weight-slim"
                label="รหัสไปรษณีย์/ตำบล/อำเภอ/จังหวัด :"
                label-cols-md="3"
              >
                <div class="align-items-center">
                  <v-select
                    class="px-0 col-md-7"
                    v-model="postcode"
                    :options="postcodeMapping"
                    label="list"
                  ></v-select>
                  <span v-if="this.valPostcode == false" style="color:red">*กรุณาระบุ</span>
                </div>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group
                class="font-weight-slim"
                label="เลขผู้เสียภาษี :"
                label-cols-md="3"
              >
                <div class="align-items-center">
                  <b-form-input v-model="companyTaxID" class="col-md-7"/>
                  <span v-if="this.valTaxID == false" style="color:red">*กรุณาระบุ</span>
                </div>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group label-cols-md="3">
                <div class="align-items-center">
                  <b-button
                    variant="primary"
                    :disabled="this.loadButton == false"
                    @click="actionCompany()"
                  >
                    <b-spinner v-if="this.loadButton == false" small/>
                    บันทึกข้อมูล
                  </b-button>
                </div>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>

      <!-- customer addres -->
      <b-card no-body v-if="this.companyId != null && this.companyId != ''">
        <b-card-header class="align-items-center">
          <h4>ที่อยู่จัดส่ง</h4>
          <b-button variant="primary" v-b-modal.address>เพิ่มที่อยู่จัดส่ง</b-button>
        </b-card-header>
        <b-card-body>
          <b-table
            responsive
            :items="addressList"
            :fields="addressFields"
            table-class="table-md-responsive text-nowrap"
          >
            <template #cell(rowID)="data">
              <feather-icon
                :id="`edit-${data.value}`"
                icon="EditIcon"
                class="cursor-pointer text-warning"
                size="20"
                @click="openAddress(data.item)"
              />
              <b-tooltip
                title="แก้ไข"
                :target="`edit-${data.value}`"
                :delay="{show: '1500'}"
              />
              <feather-icon
                :id="`del-${data.value}`"
                icon="TrashIcon"
                class="cursor-pointer text-danger ml-1"
                size="20"
                @click="deleteAddress(data.value)"
              />
              <b-tooltip
                title="ลบ"
                :target="`del-${data.value}`"
                :delay="{show: '1500'}"
              />
            </template>
          </b-table>
        </b-card-body>
      </b-card>

      <b-modal
        id="address"
        ref="address"
        title-class="h2"
        :title="this.cusIsEdit == true ? 'แก้ไขที่อยู่' : 'เพิ่มที่อยู่ใหม่'"
        @hidden="closeAddress"
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
      >
        <b-form>
          <b-card-body class="py-0 px-0">
            <b-form>
              <b-row>
                <b-col cols="12">
                  <b-form-group
                    class="font-weight-slim"
                    label="ชื่อ :"
                  >
                    <div class="align-items-center">
                      <b-form-input v-model="cusName"/>
                      <span v-if="this.valCusName == false" class="text-danger">กรุณาระบุ</span>
                    </div>
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <b-form-group
                    class="font-weight-slim"
                    label="เบอร์โทร :"
                  >
                    <div class="align-items-center">
                      <b-form-input v-model="cusPhone"/>
                      <span v-if="this.valCusPhone == false" class="text-danger">กรุณาระบุ</span>
                    </div>
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <b-form-group
                    class="font-weight-slim"
                    label="ที่อยู่ :"
                  >
                    <div class="align-items-center">
                      <b-form-textarea v-model="cusAddress"/>
                      <span v-if="this.valCusAddress == false" class="text-danger">กรุณาระบุ</span>
                    </div>
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <b-form-group
                    class="font-weight-slim"
                    label="รหัสไปรษณีย์/ตำบล/อำเภอ/จังหวัด :"
                  >
                    <div class="align-items-center">
                      <v-select
                        class="px-0 col-12"
                        v-model="cusPostcode"
                        :options="postcodeMapping"
                        label="list"
                      ></v-select>
                      <span v-if="this.valCusPostcode == false" class="text-danger">กรุณาระบุ</span>
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>
          </b-card-body>
          <div class="pt-1 float-right">
            <b-button
              @click="actionAddress()"
              variant="primary"
              :disabled="this.loadButton == false"
            >
              <b-spinner v-if="this.loadButton == false" small />
              บันทึก
            </b-button>
            <b-button class="ml-1" @click="closeAddress()" variant="outline-danger">ยกเลิก</b-button>
          </div>
        </b-form>
      </b-modal>

      <!-- company file -->
      <b-card no-body v-if="this.companyId != null && this.companyId != ''">
        <b-card-header class="align-items-center">
          <h4>เอกสาร</h4>
          <b-button variant="primary" v-b-modal.file>อัปโหลดเอกสาร</b-button>
        </b-card-header>
        <b-card-body>
          <b-table
            responsive
            :items="fileList"
            :fields="fileFields"
            table-class="table-md-responsive text-nowrap"
          >
            <template #cell(rowID)="data">
              <feather-icon
                :id="`del-${data.value}`"
                icon="TrashIcon"
                class="cursor-pointer text-danger"
                size="20"
                @click="deleteFile(data.value)"
              />
              <b-tooltip
                title="ลบ"
                :target="`del-${data.value}`"
                :delay="{show: '1500'}"
              />
            </template>
            <template #cell(fileLink)="data">
              <b-link :href="data.value" target="_blank">ดูไฟล์</b-link>
            </template>
          </b-table>
        </b-card-body>
      </b-card>

      <b-modal
        id="file"
        ref="file"
        title-class="h2"
        title="เพิ่มไฟล์"
        @hidden="closeFile"
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
      >
        <b-form>
          <b-card-body class="py-0 px-0">
            <b-form>
              <b-row>
                <b-col cols="12">
                  <b-form-group
                    class="font-weight-slim"
                    label="ไฟล์ :"
                  >
                    <div class="align-items-center">
                      <b-form-file
                        v-model="fileReal"
                        placeholder="Choose a file"
                        drop-placeholder="Drop file here..."
                      />
                      <span v-if="this.valFile == false" class="text-danger">กรุณาระบุ</span>
                    </div>
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <b-form-group
                    class="font-weight-slim"
                    label="ประเภท :"
                  >
                    <div class="align-items-center">
                      <b-form-radio-group
                      v-model="fileTypeValue"
                      :options="fileTypeList"
                    >
                    </b-form-radio-group>
                      <span v-if="this.valFileType == false" class="text-danger">กรุณาระบุ</span>
                    </div>
                  </b-form-group>
                </b-col>
                <b-col cols="12" v-if="fileTypeValue == 3">
                  <b-form-group
                    class="font-weight-slim"
                    label="ประเภทไฟล์ :"
                  >
                    <div class="align-items-center">
                      <b-form-input v-model="fileTypeName"/>
                      <span v-if="this.valFileTypeName == false" class="text-danger">กรุณาระบุ</span>
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>
          </b-card-body>
          <div class="pt-1 float-right">
            <b-button
              @click="actionFile()"
              variant="primary"
              :disabled="this.loadButton == false"
            >
              <b-spinner v-if="this.loadButton == false" small />
              บันทึก
            </b-button>
            <b-button class="ml-1" @click="closeFile()" variant="outline-danger">ยกเลิก</b-button>
          </div>
        </b-form>
      </b-modal>

    </div>
  </div>
</template>

<script>
import {
  BFormFile, BAvatar, BBadge, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput,
  BInputGroupAppend, BButton, BCardBody, BCard, BTabs, BTab, BSpinner, BRow, BCol, BFormRadioGroup,
  BFormCheckbox, BFormTextarea, BLink, BCardHeader, BFormRadio, BCardFooter, BModal, VBModal, BForm,
  BImg, BTable, VBToggle, BTooltip
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {header_token} from '@/views/token.js'
import {taobaoService_dotnet} from '@/views/global.js'
import axios from "axios";

export default {
  name: 'Taobao2youCompany',

  directives: {
    'b-toggle': VBToggle,
    'b-modal': VBModal
  },

  components: {
    BCard, BCardHeader, BCardBody, BSpinner, BRow, BCol, BFormGroup, BFormInput, BFormTextarea, BButton,
    BTable, BTooltip, BForm, BFormFile, BFormRadioGroup, BLink,

    vSelect, ToastificationContent
   },

  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      //comapny
      companyId: null,
      companyName: '',
      companyPhone: '',
      companyAddress: '',
      postcode: { list: '--รหัสไปรษณีย์ ตำบล อำเภอ จังหวัด--', 'rowID': 0 },
      postcodeMapping: [],
      companyTaxID: '',

      valName: true,
      valAddress: true,
      valTaxID: true,
      valPostcode: true,


      //address
      addressId: 0,
      addressList: [],
      addressFields: [
        { key: 'rowID', label: 'ตัวเลือก', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'fullAddress', label: 'ที่อยู่', thClass: 'text-center' },
      ],
      cusName: '',
      cusPhone: '',
      cusAddress: '',
      cusPostcode: { list: '--รหัสไปรษณีย์ ตำบล อำเภอ จังหวัด--', 'rowID': 0 },
      cusIsEdit: null,
      valCusName: true,
      valCusPhone: true,
      valCusAddress: true,
      valCusPostcode: true,


      //file
      fileId: 0,
      fileList: [],
      fileFields: [
        { key: 'rowID', label: 'ตัวเลือก', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'fileLink', label: 'ไฟล์', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'typeName', label: 'ประเภท', thClass: 'text-center', tdClass: 'text-center' },
      ],
      fileReal: null,
      fileTypeName: '',
      fileTypeValue: null,
      fileTypeList: [
        { text: 'หนังสือรับรองบริษัท', value: 1 },
        { text: 'ภพ.20', value: 2 },
        { text: 'อื่นๆ', value: 3 },
      ],
      valFile: true,
      valFileType: true,
      valFileTypeName: true,

      //load
      loadpage: true,
      loadButton: true,
    };
  },

  async created() {
    this.loadpage = false
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    this.companyId = await urlParams.get('companyID')
    if (this.companyId != null && this.companyId != '') {
      await this.getAddress()
      await this.getFile()
      await this.getCompany()
    }
    this.loadpage = true
    this.getPostcode()
  },

  methods: {
    async getPostcode(){
      if (JSON.parse(localStorage.getItem('postcode'))) {
        this.postcodeMapping = JSON.parse(localStorage.getItem('postcode'))
      } else {
        let response = await axios.get(
          taobaoService_dotnet + 'app/Customer/get-postcode-mapping',
          { headers: header_token }
        );
        response.data.forEach((e) => {
          this.postcodeMapping.push(
            {
              'list': e.postcode + " / " + e.subDistrict + " / " + e.district + " / " + e.province,
              'provinceID': e.provinceID,
              'rowID': e.rowID,
              'subDistrict': e.subDistrict,
              'district': e.district,
              'province': e.province,
              'postcode': e.postcode,
            }
          )
        })
        localStorage.setItem('postcode', JSON.stringify(this.postcodeMapping ))
      }
    },

    //company
    async getCompany() {
      let response = await axios.post(
        taobaoService_dotnet + 'app/Company/get-one-company-info',
        // "https://localhost:5001/app/Company/get-one-company-info",
        {
          "loginToken": this.userData.data.customerInfo.loginToken,
          "id": this.companyId == null || this.companyId == '' ? 0 : this.companyId
        },
        { headers: header_token }
      );
      if (response.data == '') {
        this.$router.push({path: '/company/information'})
        this.companyId = null
        this.postcode = { list: '--รหัสไปรษณีย์ ตำบล อำเภอ จังหวัด--', 'rowID': 0 }
        return
      }
      var res = response.data
      this.companyName = res.companyName
      this.companyPhone = res.phone
      this.companyAddress = res.address
      this.companyTaxID = res.taxID
      this.postcode = this.postcodeMapping.filter(x => x.rowID == res.postcodeMappingID)[0]

    },
    async actionCompany() {
      this.loadButton = false
      if (this.companyName == '') {
        this.valName = false
      } else if (this.companyAddress == '') {
        this.valAddress = false
      } else if (this.postcode == null || this.postcode.rowID == 0) {
        this.valPostcode = false
      } else if (this.companyTaxID == '') {
        this.valTaxID = false
      } else {
        let response = await axios.post(
          taobaoService_dotnet + 'app/Company/action-company-info',
          // "https://localhost:5001/app/Company/action-company-info",
          {
            "id": this.companyId == null || this.companyId == '' ? 0 : this.companyId,
            "loginToken": this.userData.data.customerInfo.loginToken,
            "companyName": this.companyName,
            "phone": this.companyPhone,
            "address": this.companyAddress,
            "postcodeMappingID": this.postcode.rowID,
            "taxID": this.companyTaxID
          },
          { headers: header_token }
        );
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'สำเร็จ',
            icon: 'CheckIcon',
            text: 'บันทึกข้อมูลเรียบร้อย',
            variant: 'success',
          },
        },
        {
          position: 'top-center',
        })
        if (response.data.isUpdate == true) {
          this.companyId = await response.data.id
          this.getCompany()
        } else {
          this.companyId = await response.data.id
          this.$router.push({path: '/company/information?companyID=' + response.data.id})
          this.getCompany()
        }
        this.valName = true
        this.valAddress = true
        this.valPostcode = true
        this.valTaxID = true
      }
      this.loadButton = true
    },

    //address
    async getAddress() {
      let response = await axios.post(
        taobaoService_dotnet + 'app/Company/get-customer-address',
        // "https://localhost:5001/app/Company/get-customer-address",
        {
          "companyID": this.companyId
        },
        { headers: header_token }
      );
      this.addressList = response.data
    },
    async actionAddress() {
      this.loadButton = false
      if (this.cusName == '') {
        this.valCusName = false
      } else if (this.cusPhone == '') {
        this.valCusPhone = false
      } else if (this.cusAddress == '') {
        this.valCusAddress = false
      } else if (this.cusPostcode == null || this.cusPostcode.rowID == 0) {
        this.valCusPostcode = false
      } else {
        let response = await axios.post(
          taobaoService_dotnet + 'app/Company/action-customer-address',
          // "https://localhost:5001/app/Company/action-customer-address",
          {
            "rowID": this.addressId,
            "companyID": this.companyId,
            "name": this.cusName,
            "phone": this.cusPhone,
            "address": this.cusAddress,
            "postcodeMappingID": this.cusPostcode.rowID
          },
          { headers: header_token }
        );
        if (response.data == 'success') {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'สำเร็จ',
              icon: 'CheckIcon',
              text: 'บันทึกที่อยู่เรียบร้อย',
              variant: 'success',
            },
          },
          {
            position: 'top-center',
          })
          this.getAddress()
          this.closeAddress()
        }
      }
      this.loadButton = true
    },
    async deleteAddress(id) {
      this.$swal({
        title: 'ลบที่อยู่จัดส่ง ?',
        text: 'คุณต้องการลบที่อยู่จัดส่งหรือไม่ ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        customClass: {
          confirmButton: 'btn btn-warning',
          cancelButton: 'btn btn-outline-primary ml-1',
        },
        buttonsStyling: false,
      }).then( async result => {
        if (result.value) {
          let response = await axios.post(
            taobaoService_dotnet + 'app/Company/delete-customer-address',
            // "https://localhost:5001/app/Company/delete-customer-address",
            {
              "rowID": id,
            },
            { headers: header_token }
          );
          if (response.data == 'success') {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'สำเร็จ',
                icon: 'CheckIcon',
                text: 'ลบที่อยู่จัดส่งเรียบร้อย',
                variant: 'success',
              },
            },
            {
              position: 'top-center',
            })
            this.getAddress()
          }
        }
      })
    },
    openAddress(item) {
      this.addressId = item.rowID
      this.cusName = item.name
      this.cusPhone = item.phone
      this.cusAddress = item.address
      this.cusPostcode = this.postcodeMapping.filter(x => x.rowID == item.postcodeMappingID)[0]
      this.cusIsEdit = true
      this.$refs['address'].show()
    },
    closeAddress() {
      this.addressId = 0
      this.cusName = ''
      this.cusPhone = ''
      this.cusAddress = ''
      this.cusPostcode = { list: '--รหัสไปรษณีย์ ตำบล อำเภอ จังหวัด--', 'rowID': 0 }
      this.cusIsEdit = null
      this.valCusName = true
      this.valCusPhone = true
      this.valCusAddress = true
      this.valCusPostcode = true
      this.loadButton = true
      this.$refs['address'].hide()
    },

    //file
    async getFile() {
      let response = await axios.post(
        taobaoService_dotnet + 'app/Company/get-company-file',
        // "https://localhost:5001/app/Company/get-company-file",
        {
          "companyID": this.companyId
        },
        { headers: header_token }
      );
      this.fileList = response.data
    },
    async actionFile() {
      this.loadButton = false
      if (this.fileReal == null) {
        this.valFile = false
      } else if (this.fileTypeValue == null) {
        this.valFileType = false
      } else if (this.fileTypeValue == 3 && this.fileTypeName == '') {
        this.valFileTypeName = false
      } else {
        var fileUrl = await this.addPhoto(this.fileReal)
        let response = await axios.post(
          taobaoService_dotnet + 'app/Company/action-company-file',
          // "https://localhost:5001/app/Company/action-company-file",
          {
            "rowID": 0,
            "companyID": this.companyId,
            "fileLink": fileUrl,
            "typeID": this.fileTypeValue,
            "typeName": this.fileTypeValue == 3 ? this.fileTypeName : this.fileTypeList.filter( x => x.value == this.fileTypeValue)[0].text
          },
          { headers: header_token }
        );
        if (response.data == 'success') {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'สำเร็จ',
              icon: 'CheckIcon',
              text: 'บันทึกไฟล์รียบร้อย',
              variant: 'success',
            },
          },
          {
            position: 'top-center',
          })
          this.getFile()
          this.closeFile()
        }
      }
      this.loadButton = true
    },
    async deleteFile(id) {
      this.$swal({
        title: 'ลบไฟล์เอกสาร ?',
        text: 'คุณต้องการลบไฟล์เอกสารหรือไม่ ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        customClass: {
          confirmButton: 'btn btn-warning',
          cancelButton: 'btn btn-outline-primary ml-1',
        },
        buttonsStyling: false,
      }).then( async result => {
        if (result.value) {
          let response = await axios.post(
            taobaoService_dotnet + 'app/Company/delete-company-file',
            // "https://localhost:5001/app/Company/delete-company-file",
            {
              "rowID": id,
            },
            { headers: header_token }
          );
          if (response.data == 'success') {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'สำเร็จ',
                icon: 'CheckIcon',
                text: 'ลบไฟล์เอกสารเรียบร้อย',
                variant: 'success',
              },
            },
            {
              position: 'top-center',
            })
            this.getFile()
          }
        }
      })
    },
    openFile() {

    },
    closeFile() {
      this.fileReal = null
      this.fileTypeValue = null
      this.fileTypeName = ''
      this.valFile = true
      this.valFileType = true
      this.valFileTypeName = true
      this.loadButton = true
      this.$refs['file'].hide()
    },

    //change file
    async addPhoto(file) {
      var fileLink = null
      var FormData = require('form-data');
      var data = new FormData();
      data.append('', file);
      var config = {
        method: 'post',
        url: taobaoService_dotnet + 'api/General/upload-file-with-type?UploadType=2',
        headers: {
          'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U',
          'Content-Type': 'application/json',
        },
        data : data
      };
      await axios(config)
      .then(function (response) { fileLink = response.data })
      .catch(function (error) { console.log(error); });
      return fileLink[0]
    }
  },
};
</script>

<style lang="scss" scoped>

</style>